export default {
  formContainer: {
    paddingBottom: '8px',
    marginBottom: '8px',
    borderBottom: '1px dotted rgba(0,0,0,0.12)'
  }
}
